import {forwardRef} from 'react'
import {AvatarFallback, AvatarImage} from '@radix-ui/react-avatar'
import {AvatarRoot, StyledAvatarWrapper} from '@components/ui/avatar/style.ts'

interface AvatarProps extends React.HTMLAttributes<HTMLDivElement> {
    name: string
    imageUrl?: string
    size?: 'sm' | 'md' | 'lg' | 'xs'
}

const getInitials = (name: string): string => {
    if (!name || typeof name !== 'string') {
        return ''
    }

    const initials = name.match(/\b\w/g)
    if (initials) {
        return initials.length <= 2 ? initials.join('') : `${initials[0]}${initials.at(-1)}`
    }

    return ''
}

export const Avatar = forwardRef<HTMLDivElement, AvatarProps>(({name, imageUrl, size = 'md', ...props}, ref) => (
    <StyledAvatarWrapper ref={ref} {...props}>
        <AvatarRoot $size={size}>
            <AvatarImage src={imageUrl} alt={name} />
            <AvatarFallback>{getInitials(name)}</AvatarFallback>
        </AvatarRoot>
    </StyledAvatarWrapper>
))

Avatar.displayName = 'Avatar'
